import { combineReducers } from "redux"
import user from "./user"
import recharge from "./recharge"
import affiliate from "./affiliate"
import captcha from "./captcha"
import invite from "./invite"

export default combineReducers({
  user,
  recharge,
  affiliate,
  captcha,
  invite
})
